import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Card, Grid, Icon, CircularProgress, Alert } from "@mui/material";
import CompraConfirmacionModal from "./CompraConfirmacionModal";
import comprasService from "services/comprasService";

function ComprarLicencias() {
  const [modalOpen, setModalOpen] = useState(false);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [planes, setPlanes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  // Cargar paquetes al montar el componente
  useEffect(() => {
    cargarPaquetes();
  }, []);

  /**
   * Obtiene los paquetes disponibles desde el backend
   */
  const cargarPaquetes = async () => {
    try {
      setCargando(true);
      setError(null);
      
      const paquetes = await comprasService.getPaquetes();
      
      // Mapear los paquetes al formato esperado por el componente
      const planesFormateados = paquetes.map(paquete => 
        comprasService.mapPaqueteToFrontend(paquete)
      );
      
      setPlanes(planesFormateados);
      console.log('📦 Paquetes cargados:', planesFormateados);
    } catch (err) {
      console.error('Error al cargar paquetes:', err);
      setError('No se pudieron cargar los paquetes disponibles. Por favor, intenta nuevamente.');
    } finally {
      setCargando(false);
    }
  };

  const handleComprar = (plan) => {
    console.log('🛍️ Plan seleccionado:', plan);
    setPlanSeleccionado(plan);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setPlanSeleccionado(null);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="success"
              >
                <MDTypography variant="h6" color="white">
                  Comprar Licencias
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={2} pb={3}>
                <MDBox display="flex" alignItems="center" mb={3}>
                  <Icon fontSize="large" sx={{ mr: 2 }}>shopping_cart</Icon>
                  <MDTypography variant="h5">
                    Adquiere licencias para tus evaluaciones
                  </MDTypography>
                </MDBox>

                {/* Mostrar spinner mientras carga */}
                {cargando && (
                  <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                    <CircularProgress color="success" />
                  </MDBox>
                )}

                {/* Mostrar error si falla la carga */}
                {error && (
                  <Alert severity="error" sx={{ mb: 3 }}>
                    {error}
                    <MDButton
                      variant="text"
                      color="error"
                      size="small"
                      onClick={cargarPaquetes}
                      sx={{ ml: 2 }}
                    >
                      Reintentar
                    </MDButton>
                  </Alert>
                )}
                
                {/* Mostrar paquetes */}
                {!cargando && !error && (
                  <Grid container spacing={3}>
                  {planes.map((plan) => (
                    <Grid item xs={12} md={4} key={plan.id}>
                      <Card variant="outlined" sx={{ height: '100%' }}>
                        <MDBox p={3} textAlign="center" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                          <MDBox sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Icon fontSize="large" color={plan.color}>
                              {plan.icon}
                            </Icon>
                          </MDBox>
                          <MDTypography variant="h5" mt={2} mb={1}>
                            {plan.nombre}
                          </MDTypography>

                          <MDTypography variant="body2" color="text" mb={2}>
                            {plan.tests} licencias
                          </MDTypography>

                          <MDTypography 
                            variant="body2" 
                            color="text" 
                            mb={2} 
                            sx={{ minHeight: '48px' }} 
                          >
                            {plan.descripcion}
                          </MDTypography>

                          <MDTypography 
                            variant="h3" 
                            color={plan.color} 
                            fontWeight="bold"
                            mt={-1}   // <-- ajustado: sube el precio un poco
                          >
                            ${plan.precio.toLocaleString('es-CO')}
                          </MDTypography>
                          
                          <MDBox sx={{ mt: 3 }}>  {/* <-- fijado: mantiene botón en la posición original */}
                            <MDButton 
                              variant="gradient" 
                              color={plan.color} 
                              fullWidth
                              onClick={() => handleComprar(plan)}
                            >
                              Comprar
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  ))}
                  </Grid>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modal de confirmación */}
      <CompraConfirmacionModal
        open={modalOpen}
        onClose={handleCloseModal}
        planData={planSeleccionado}
      />
    </DashboardLayout>
  );
}

export default ComprarLicencias;